import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServiceLocatorService } from '@ncs/ncs-lib';
import { UiformBaseComponent } from '../components/uiform/uiform-base/uiform-base.component';
declare var bootstrap: any;

@Component({
  selector: 'app-child-form-data-list',
  templateUrl: './child-form-data-list.component.html',
  styleUrls: ['./child-form-data-list.component.scss'],
})
export class ChildFormDataListComponent extends UiformBaseComponent {
  @ViewChild('content')
  content!: ElementRef;
  @Input() uiChildformId: any;
  @Input() foreignKey: any;
  @Input() foreignId: any;
  @Input() parentChildUsecase: any;
  @Input() flag: any;

  public parentKey: any = '';

  public entryform: any = {
    data: { id: 0 }, //form data
  };

  imagePreviews: { [key: string]: string | ArrayBuffer | null } = {};
  fileErrors: { [key: string]: boolean } = {};
  imageSizes: { [key: string]: boolean } = {};
  imagePreview: string | ArrayBuffer | null = null;
  sortedField: string | null = null;
  sortOrder: 'ASC' | 'DESC' | null = null;
  filteredData: any[] = [];
  public minDate: string | null = null;
  public maxDate: string | null = null;
  public usecaseSchema: any = {};

  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
  ) {
    super(locator, route);
    let _self = this;
    _self.locator.config
      .getProperty('endpoint.ui.forms')
      .then((property: string) => {
        _self.initApiEndpoint(property);
      });
  }

  override ngOnInit() {
    let _self = this;
    _self.locator.config
      .getProperty('endpoint.ui.forms')
      .then((property: string) => {
        if (_self.uiChildformId)
          this.get(_self.uiChildformId, function () {
            _self.form.inputerror['email'] = '';
            _self.usecaseId = _self.form.data.userstoryId;
            _self.getUsecaseSchema(false, () => {
              // _self.getUiformData(_self.uiChildformId);
              _self.getUiformDatas();
            });
          });
      });
  }

  resetAndGetData() {
    let _self = this;
    _self.resetUiformData();
  }

  public getUiformData(id: number | null) {
    let _self = this;
    if (!id || !(id > 0)) {
      return;
    }
    _self.id = id;
    let updatedName = _self.usecase['collectionName'].replace(/\./g, '/');
    _self.apiurl =
      _self.locator.config.get('endpoint.api.v1') + '/' + updatedName;
    let url = _self.apiurl + '/get/' + id;
    _self.locator.http.get(url, function (res: any, error: any) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }

      if (res.result['data'] != undefined) {
        _self.cleanAndSetData(res.result['data']);
      }
    });
  }

  cleanAndSetData(data: any) {
    let _self = this;
    const sanitizedItem: any = {};
    _self.usecaseAttributes.forEach((attr: any) => {
      let key = attr['code'];
      if (key in data) {
        sanitizedItem[key] = data[key];
      }
    });
    if ('id' in data) {
      sanitizedItem['id'] = data['id'];
    }
    _self.entryform['data'] = sanitizedItem;
  }

  public async getUiformDatas() {
    let _self = this;
    let searchParams: any = {};
    let updatedName = _self.usecase['collectionName'].replace(/\./g, '/');

    if (
      _self.usecase?.parentUsecases &&
      _self.parentChildUsecase?.collectionName
    ) {
      const parentUsecases = _self.usecase.parentUsecases;
      const targetCollectionName = _self.parentChildUsecase.collectionName;
      const matchingParent: any = Object.entries(parentUsecases).find(
        ([key]) => key === targetCollectionName,
      );
      if (matchingParent) {
        _self.parentKey = matchingParent[1]?.id;
        if (_self.parentKey) {
          searchParams[_self.parentKey] = _self.foreignId;
        }
      }
    }

    _self.apiurl =
      _self.locator.config.get('endpoint.api.v1') + '/' + updatedName;
    let url = _self.apiurl + '/search';
    _self.locator.http.post(url, searchParams, function (res: any, error: any) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.filteredData = [...res.result['data']];
      console.log('Search Result ', res.result['data']);
    });
  }

  override search(callback?: any): void {
    let _self = this;
    _self.getUiformDataList();
  }

  override populateForm(form: any, data: any): void {
    super.populateForm(form, data);

    if (data.groupLabels) {
      form.groupLabels = data.groupLabels;
    }
    if (data.childFormList) {
      form.childFormList = data.childFormList;
    }
  }

  getGroupsField(label: any) {
    return this.form.data.fields.filter((field: any) => field.group == label);
  }

  getDefaultColums(columns: any, field: any) {
    let size = 12;
    if (columns) {
      size = 12 / columns;
    }
    return 12;
  }

  getDescription(field: any) {
    if (field['description']) {
      return field['description'];
    }

    return field['label'];
  }

  getColums(columns: any, field: any) {
    let size = 12;
    if (columns) {
      size = 12 / columns;
    }
    if (field['colsize'] && field['colsize'] > 0) {
      let tempSize = size * field['colsize'];
      if (tempSize <= 12) {
        return tempSize;
      } else {
        return 12;
      }
    }
    return size;
  }

  evaluateCondition(attr: any): boolean {
    try {
      this.entryform.data[this.parentKey] = this.foreignId;
      if (attr['show']) {
        const condition = attr['show'];
        const context = this.entryform.data; // Assuming `this.form` is the context containing the variables
        // Create a new Function that safely evaluates the condition
        const fn = new Function(
          ...Object.keys(context),
          `return ${condition};`
        );
        return fn(...Object.values(context));
      }
      return true; // Return true if no condition is provided
    } catch (error) {
      console.error('Error evaluating condition:', error);
      return false; // Return false if an error occurs
    }
  }

  getRows(field: any) {
    if (field['rowsize'] && field['rowsize'] > 1 && field['rowsize'] < 4) {
      return 'row-size-' + field['rowsize'];
    }
    return '';
  }

  getFieldNotIngroup() {
    return (
      this.form?.data?.fields?.filter(
        (field: any) => !field?.group && field?.group == null
      ) || []
    );
  }

  public getInputError(name: string) {
    let _self = this;
    let errMsg = '';
    let ie = _self.entryform['inputerror'];
    if (ie && ie[name]) {
      errMsg = ie[name];
    }
    return errMsg;
  }

  sortTable(field: string): void {
    let _self = this;
    if (this.sortedField === field) {
      this.sortOrder = this.sortOrder === 'ASC' ? 'DESC' : 'ASC';
    } else {
      this.sortedField = field;
      this.sortOrder = 'ASC';
    }
    _self.form.searchParams['orderBy'] = this.sortedField;
    _self.form.searchParams['asc'] = this.sortOrder;
    _self.form.searchParams[_self.parentKey] = _self.foreignId;
    _self.searchValues[_self.parentKey] = _self.foreignId;
    _self.getUiformDataList();
  }

  public getUiformDataList() {
    let _self = this;
    let list_key = 'uiform_listdata';
    if (list_key in localStorage) {
      const jsonData = localStorage.getItem(list_key);
      if (jsonData) {
        _self.usecaseData = JSON.parse(jsonData);
        _self.filteredData = [..._self.usecaseData];
        localStorage.removeItem(list_key);
        return;
      }
    }
    this.getUsecaseDataList();
  }

  override processData() {
    this.filteredData = [...this.usecaseData];
  }

  checkRuleExecute(code: any) {
    let fields = this.form.data.fields.filter(
      (field: any) => field?.rule && field?.rule !== '' && field?.code == code
    );
    fields.forEach((field: any) => {
      this.handleRuleExecute(field, null);
    });
  }

  handleRuleExecute(field: any, event: any) {
    let _self = this;
    let ruleData: any;
    _self.entryform['error'] = [];
    _self.entryform['message'] = '';
    _self.entryform['inputerror'] = [];
    ruleData = { ..._self.entryform.data };
    //ruleData = _self.entryform.data;
    ruleData['collectionName'] = _self.usecase['collectionName'];

    let url: any =
      _self.locator.config.get('endpoint.application.rules') +
      '/' +
      'execute/' +
      field.rule;

    _self.locator.http.post(url, ruleData, function (res: any, error: any) {
      if (error) {
        return;
      }
      _self.entryform.data = { ..._self.entryform.data, ...res.result };
      _self.entryform['error'] = !res.success;
      _self.entryform['message'] = res.message;
      _self.entryform['inputerror'] = Object.values(
        res.result['inputerror']
      ).join(', ');
    });
  }

  public onChange(e: any, val: any) {
    let _self = this;
    let l = _self.form.preload[e['primaryUsecase']];
    let col = e['depAttribute'];
    for (let i = 0; i < l.length; i++) {
      if (l[i]['id'] == val.target.value) {
        _self.entryform.data[col] = l[i]['name'];
      }
    }
    //Check Primary Usecase Dependency Filter
    if (
      _self.usecase !== undefined &&
      _self.usecase?.parentUsecaseDependency !== undefined &&
      _self.usecase?.parentUsecaseDependency?.e['primaryUsecase'] !== undefined
    ) {
      _self.primaryUsecaseDependencyFilter(
        _self.usecase['parentUsecaseDependency'][e['primaryUsecase']],
        val
      );
    }
  }

  primaryUsecaseDependencyFilter(data: any, val: any) {
    let _self = this;
    let key = val['target']['id'];
    let [appCode, codes] = (data['code'] ?? '').toString().split('.');
    let url =
      _self.locator.config.get('endpoint.api.v1') +
      '/' +
      appCode +
      '/' +
      codes +
      '/preloadData';
    let searchParams = {
      [key]: parseFloat(val['target']['value']),
    };
    _self.locator.http.post(
      url,
      searchParams,
      function (res: any, error: boolean) {
        if (error) {
          _self.entryform['error'] = true;
          _self.entryform['message'] = error;
          return;
        }
        _self.form.preload[data['code']] = res.result[data['code']];
      }
    );
  }

  onFileChooseClicked(fileInput: any, code: any) {
    if (fileInput) {
      fileInput.value = '';
    }
    this.imageSizes[code] = false;
    this.imagePreviews[code] = null;
    this.fileErrors[code] = false;
  }

  onImageFileChanged(event: any, code: string, imageId: any) {
    const file = event.target.files[0];
    if (!file) return;
    // Validate file type
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
    if (!allowedTypes.includes(file.type)) {
      this.fileErrors[code] = true;
      this.imageSizes[code] = false;
      this.imagePreviews[code] = null;
      return;
    } else {
      this.fileErrors[code] = false;
    }

    // Validate file size (1 MB)
    if (file.size > 1024 * 1024) {
      this.imageSizes[code] = true;
      this.fileErrors[code] = false;
      this.imagePreviews[code] = null;
      return;
    } else {
      this.imageSizes[code] = false;
    }

    // Step 1: Show Preview First
    const reader = new FileReader();
    reader.onload = (e) => {
      this.imagePreviews[code] = e.target?.result as string;
      this.cdr.detectChanges();
      // Step 2: Upload After Preview is Ready
      this.uploadFileToServer(file, code, imageId);
    };

    reader.readAsDataURL(file);
  }

  uploadFileToServer(file: File, code: string, imageId: any) {
    if (imageId === null || imageId === undefined) {
      imageId = 0;
    }

    let url = this.getAPIBaseUrl(
      'doc/' + this.entryform.data['id'] + '/' + imageId + '/' + code
    );

    var param = {
      id: this.form.data.id,
    };

    this.locator.http.postMutipart(url, param, file, (res: any, error: any) => {
      if (error) {
        alert(error);
        return;
      }

      this.entryform.error = !res.success;
      this.entryform.message = res.result.message;
      if (res.success) {
        this.entryform.message = 'File is uploaded';
        this.entryform.data[code] = res.result.data[code];
        this.changeDoc();
        this.getDoc(this.entryform.data[code]);

        // ✅ Ensure UI updates after API response
        this.cdr.detectChanges();
      }
    });
  }

  public onFileChanged(event: any, code: string, imageId: any) {
    const fileObj = event.target.files[0];
    var _self = this;
    if (imageId === null || imageId === undefined) {
      imageId = 0;
    }
    let url = _self.getAPIBaseUrl(
      'doc/' + _self.entryform.data['id'] + '/' + imageId + '/' + code
    );

    var param = {
      id: this.form.data.id,
    };
    this.locator.http.postMutipart(
      url,
      param,
      fileObj,
      function (res: any, error: any) {
        if (error) {
          alert(error);
          return;
        }
        _self.entryform.error = !res.success;
        _self.entryform.message = res.result.message;
        if (res.success) {
          _self.entryform.message = 'file is uploaded';
          _self.entryform.data[code] = res.result.data[code];
          _self.changeDoc();
          _self.getDoc(_self.form.data[code]);
        }
      }
    );
  }

  onDateChange(event: any, code: string, type: string) {
    if (type === 'date') {
      const selectedDate = event.target.value;
      this.entryform.data[code] = selectedDate ? selectedDate : null;
    }
  }

  getDateMin(
    min: string,
    max: string,
    type: string,
    futureDate?: number,
    pastDate?: number,
    pastDateLimit?: number,
    futureDateLimit?: number
  ) {
    if (type === 'date') {
      const today = new Date();
      const todayStr = today.toISOString().split('T')[0];

      // Calculate past limit date
      let pastLimitStr = min;
      if (pastDateLimit !== undefined) {
        const pastLimitDate = new Date();
        pastLimitDate.setFullYear(today.getFullYear() - pastDateLimit);
        pastLimitStr = pastLimitDate.toISOString().split('T')[0];
      }

      // Calculate future limit date
      let futureLimitStr = max;
      if (futureDateLimit !== undefined) {
        const futureLimitDate = new Date();
        futureLimitDate.setFullYear(today.getFullYear() - futureDateLimit);
        futureLimitStr = futureLimitDate.toISOString().split('T')[0];
      }

      // Set minDate and maxDate based on conditions
      this.minDate = pastDate === 1 ? todayStr : pastLimitStr;
      this.maxDate = futureDate === 1 ? todayStr : futureLimitStr;
    }
  }

  restrictDecimalPlaces(event: Event, e: any, placeValue: number): void {
    const input = event.target as HTMLInputElement;
    if (!input.value) {
      return;
    }
    const value = input.value;
    const parts = value.split('.');

    if (parts.length === 2 && parts[1].length > placeValue) {
      this.entryform['error'] = true;
      this.entryform['message'] =
        'Only ' + placeValue + ' decimal value allowed on ' + e.label;
      this.entryform.data[e.code] = `${parts[0]}.${parts[1].substring(
        0,
        placeValue
      )}`;
      input.value = `${parts[0]}.${parts[1].substring(0, placeValue)}`;
    }
  }

  fieldButtonSubmit(button: string) {
    let _self = this;

    if (button === 'save') {
      _self.onSave();
    }

    if (button === 'delete') {
      _self.onDelete();
    }

    if (button === 'new') {
      _self.onNew();
    }
  }

  filterBtns() {
    return this.form.data.buttons.filter(
      (btn: any) => btn['name'] != 'list' || btn['name'] != 'cancel'
    );
  }

  onSave() {
    //this.entryform.data['uiformId'] = this.form.data['id'];
    this.saveUiformData();
  }

  // public saveUiformData() {

  //   console.log("Hello world i am here to inform you that i am glade to have you");

  //   let _self = this;
  //   _self.entryform['error'] = [];
  //   _self.entryform['message'] = '';
  //   _self.entryform['inputerror'] = [];

  //   console.log("Entry form  .....", _self.entryform['data']);

  //   let url = _self.urlRewrite(
  //     _self.getAPIBaseUrl(_self.form.data.code + '/saveForm')
  //   );

  //   _self.locator.http.post(
  //     url,
  //     _self.entryform['data'],
  //     function (res: any, error: boolean) {
  //       if (error) {
  //         alert('Server Error:' + error);
  //         return;
  //       }
  //       _self.entryform['error'] = !res.success;
  //       _self.entryform['message'] = res.message;
  //       if (res.result?.inputerror?.key) {
  //         _self.entryform['inputerror'] = Object.values(
  //           _self.entryform['inputerror'] || {}
  //         ).join(', ');
  //       } else {
  //         _self.entryform['inputerror'] = Object.values(
  //           res.result?.inputerror || {}
  //         ).join(', ');
  //       }
  //       if (res.success) {
  //         _self.entryform['data']['id'] = res.result['data']['id'];
  //         _self.getUiformDatas();
  //       }
  //     }
  //   );
  // }

  public saveUiformData() {
    let _self = this;
    _self.entryform['error'] = [];
    _self.entryform['message'] = '';
    _self.entryform['inputerror'] = [];

    // ── Transform date/time fields before sending ──────────────────────────
    const raw = { ..._self.entryform['data'] };

    // idate: "2026-04-22" → "2026-04-22T00:00:00.000Z"
    if (raw.idate) {
      raw.idate = new Date(raw.idate + 'T00:00:00.000Z').toISOString();
    }

    // itime: "22:21" → "1970-01-01T16:51:00.000Z"  (converted from local to UTC)
    if (raw.itime) {
      const [hours, minutes] = raw.itime.split(':').map(Number);
      const d = new Date(Date.UTC(1970, 0, 1, hours, minutes, 0, 0));
      raw.itime = d.toISOString();
    }

    // dataandtime: "2026-04-16T21:59" (local) → "2026-04-16T16:29:00.000Z" (UTC ISO)
    if (raw.dataandtime) {
      raw.dataandtime = new Date(raw.dataandtime + ':00').toISOString();
    }
    // ──────────────────────────────────────────────────────────────────────

    let url = _self.urlRewrite(
      _self.getAPIBaseUrl(_self.form.data.code + '/saveForm'),
    );

    _self.locator.http.post(
      url,
      raw, // ← send transformed copy, not the original
      function (res: any, error: boolean) {
        if (error) {
          alert('Server Error:' + error);
          return;
        }
        _self.entryform['error'] = !res.success;
        _self.entryform['message'] = res.message;
        if (res.result?.inputerror?.key) {
          _self.entryform['inputerror'] = Object.values(
            _self.entryform['inputerror'] || {},
          ).join(', ');
        } else {
          _self.entryform['inputerror'] = Object.values(
            res.result?.inputerror || {},
          ).join(', ');
        }
        if (res.success) {
          _self.entryform['data']['id'] = res.result['data']['id'];
          _self.getUiformDatas();
        }
      },
    );
  }

  onDelete() {
    this.deleteUseCaseData(this.id, () => {
      this.resetUiformData();
    });
  }

  override async deleteUseCaseData(id: number | null, callback?: any) {
    await super.deleteUseCaseData(id, () => {
      this.getUiformDatas();
    });
  }

  resetUiformData() {
    let _self = this;
    _self.entryform['data'] = {};
  }

  onNew() {
    this.resetUiformData();
  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }

    getString1(value: string, type: string, timeType?: string): string {
   
    if (type === 'time' && value) {
      const [hours, minutes] = value.split(':').map(Number);
      if (timeType === '12') {
        const hour12 = hours % 12 || 12;
        const ampm = hours < 12 ? 'AM' : 'PM';
        return `${hour12}:${minutes.toString().padStart(2, '0')} ${ampm}`;
      }
      // Default is 24-hour
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  }
  
    return value; // for other types
  }

  
  getLocationObject(value: any): { lat: number; lng: number } | null {
  if (!value) return null;

  // If value is already an object with lat/lng
  if (typeof value === 'object' && value.lat != null && value.lng != null) {
    return { lat: Number(value.lat), lng: Number(value.lng) };
  }

  // If value is a string like "{lat: 10, lng: 20}" or "lat:10,lng:20"
  if (typeof value === 'string') {
    try {
      // Normalize string to JSON-like format
      let cleaned = value
        .replace(/lat\s*:\s*/i, '"lat":')
        .replace(/lng\s*:\s*/i, '"lng":')
        .replace(/'/g, '"')
        .replace(/\s+/g, ''); // remove whitespace

      const obj = JSON.parse(cleaned);
      if (obj.lat != null && obj.lng != null) {
        return { lat: Number(obj.lat), lng: Number(obj.lng) };
      }
      return null;
    } catch (e) {
      console.error('Invalid location string:', value, e);
      return null;
    }
  }

  return null;
}

  defaultLat = 28.6139; // fallback to Delhi or some default
  defaultLng = 77.209;
  activeMapCode: string | null = null;

  setCurrentLocation(code: string) {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;

          if (!this.entryform.data[code]) {
            this.entryform.data[code] = {};
          }

          this.entryform.data[code].lat = lat;
          this.entryform.data[code].lng = lng;
        },
        (error) => {
          alert(
            'Unable to get your location. Please allow location access in the browser.',
          );
        },
      );
    } else {
      alert('Geolocation is not supported by your browser.');
    }
  }

  viewOnMap(code: string) {
    const location = this.entryform.data[code];
    const lat = location?.lat;
    const lng = location?.lng;

    if (lat && lng) {
      const mapUrl = `https://www.google.com/maps?q=${lat},${lng}`;
      window.open(mapUrl, '_blank');
    } else {
      alert('Location not available. Please set the location first.');
    }
  }

  clearLocation(code: string) {
    if (this.entryform.data[code]) {
      this.entryform.data[code].lat = null;
      this.entryform.data[code].lng = null;
    }
  }

  //------show Password---------
  showPassword: boolean = false;

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  enforceMaxDate(event: Event, fieldCode: string, fieldType: string): void {
    if (fieldType === 'date') {
      const input = event.target as HTMLInputElement;
      const maxDate = new Date('9999-12-31');
      const enteredDate = new Date(input.value);

      // If invalid or too large, reset
      if (enteredDate > maxDate) {
        input.value = '9999-12-31';
        this.entryform.data[fieldCode] = '9999-12-31';
      } else {
        this.entryform.data[fieldCode] = input.value;
      }
    }
  }

  public convertIntoLocalDate(utc: any) {
    if (!utc) return null;
    const d = new Date(utc);
    const year = d.getFullYear();
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const day = d.getDate().toString().padStart(2, '0');
    const date = `${year}-${month}-${day}`;
    return date;
  }

  onCheckboxChange(e: any, option: any, event: any) {
    event.stopPropagation();
    if (!this.entryform.data[e.code]) {
      this.entryform.data[e.code] = [];
    }
    if (event.target.checked) {
      if (!this.entryform.data[e.code].includes(option)) {
        this.entryform.data[e.code].push(option);
      }
    } else {
      this.entryform.data[e.code] = this.entryform.data[e.code].filter(
        (o: any) => o !== option,
      );
    }
    this.onChange(e, this.entryform.data[e.code]);
  }

  toggleDropdown(e: any) {
    if (
      e['readOnly'] ||
      (e.allowChangeAfterInitial == 1 && this.entryform.data['id'] > 0)
    ) {
      return;
    }
    e.isDropdownOpen = !e.isDropdownOpen;
  }

  getSelectedText(e: any) {
    const value = this.entryform.data[e.code];
    if (e['multipleSelect'] == 1 && Array.isArray(value) && value.length) {
      return value.join(', ');
    }
    return '';
  }

  getTruncateLimit(columns?: number): number {
    if (!columns || columns <= 1) return 150;
    if (columns === 2) return 70;
    if (columns === 3) return 35;
    if (columns === 4) return 25;
    return 15;
  }

  onRadioChange(attribute: any, option: string): void {
    // Single select: set the model property to the selected option value
    this.entryform.data[attribute.code] = option;
    // Optionally call your main change handler if needed:
    // this.onChange(attribute, null);
  }

  getStringitime(value: string, type: string, timeType?: string): string {
    if (type === 'itime' && value) {
      let hours: number;
      let minutes: string;

      // Handle plain time format (23:12)
      if (/^\d{1,2}:\d{2}$/.test(value)) {
        const parts = value.split(':');
        hours = Number(parts[0]);
        minutes = parts[1];
      } else {
        const d = new Date(value); // ISO datetime
        hours = d.getHours();
        minutes = d.getMinutes().toString().padStart(2, '0');
      }

      if (timeType === '12') {
        const hour12 = hours % 12 || 12;
        const ampm = hours < 12 ? 'AM' : 'PM';
        return `${hour12}:${minutes} ${ampm}`;
      }
      return `${hours.toString().padStart(2, '0')}:${minutes}`;
    }
    return value;
  }

  getAppDocThumbnail(skey: number) {
    let _self = this;
    if (!skey) {
      if (_self.applogo) {
        skey = Number(_self.applogo);
      } else {
        skey = 0;
      }
    }
    let docAPI = this.locator.config.get('DOC_API');
    let url = docAPI + 'th/' + skey + '?t=' + this.imageTimestamp;
    return url;
  }

  /**
   * Get application doc
   * @param skey
   */
  getAppDoc(skey: number) {
    let _self = this;
    if (!skey) {
      if (_self.applogo) {
        skey = Number(_self.applogo);
      } else {
        skey = 0;
      }
    }
    return _self.getDoc(skey);
  }
}
